import { ResponseSetTempHealthTargetData } from 'api/profile';
import { HealthGoalTypesType } from 'components/molecules/HealthGoalSelection/HealthGoalSelection';
import { ProfileDataType } from './profile';
import {
	CHANGE_ANAMNESIS_DISCLAIMER_ACCEPTED,
	REQUEST_FINISH_ANAMNESIS,
	REQUEST_FINISH_ANAMNESIS_FAILURE,
	REQUEST_FINISH_ANAMNESIS_SUCCESS,
	REQUEST_FINISH_ONBOARDING,
	REQUEST_FINISH_ONBOARDING_FAILURE,
	REQUEST_FINISH_ONBOARDING_LOADING,
	REQUEST_FINISH_ONBOARDING_SUCCESS,
	REQUEST_SAVE_ACCEPT_HEALTH_TARGET,
	REQUEST_SAVE_ACCEPT_HEALTH_TARGET_FAILURE,
	REQUEST_SAVE_ACCEPT_HEALTH_TARGET_SUCCESS,
	REQUEST_SAVE_ACTIVITY_LEVEL,
	REQUEST_SAVE_ACTIVITY_LEVEL_FAILURE,
	REQUEST_SAVE_ACTIVITY_LEVEL_SUCCESS,
	REQUEST_SAVE_AGE,
	REQUEST_SAVE_AGE_FAILURE,
	REQUEST_SAVE_AGE_SUCCESS,
	REQUEST_SAVE_COACH,
	REQUEST_SAVE_COACH_FAILURE,
	REQUEST_SAVE_COACH_SUCCESS,
	REQUEST_SAVE_DIETARY_HABITS,
	REQUEST_SAVE_DIETARY_HABITS_FAILURE,
	REQUEST_SAVE_DIETARY_HABITS_SUCCESS,
	REQUEST_SAVE_DSGVO,
	REQUEST_SAVE_DSGVO_FAILURE,
	REQUEST_SAVE_DSGVO_SUCCESS,
	REQUEST_SAVE_GENDER,
	REQUEST_SAVE_GENDER_FAILURE,
	REQUEST_SAVE_GENDER_SUCCESS,
	REQUEST_SAVE_HEALTH_TARGET,
	REQUEST_SAVE_HEALTH_TARGET_FAILURE,
	REQUEST_SAVE_HEALTH_TARGET_SUCCESS,
	REQUEST_SAVE_HEIGHT,
	REQUEST_SAVE_HEIGHT_FAILURE,
	REQUEST_SAVE_HEIGHT_SUCCESS,
	REQUEST_SAVE_PARTICIPATE_COMPETITION,
	REQUEST_SAVE_SLOGAN,
	REQUEST_SAVE_SLOGAN_FAILURE,
	REQUEST_SAVE_SLOGAN_SUCCESS,
	REQUEST_SAVE_WEIGHT,
	REQUEST_SAVE_WEIGHT_FAILURE,
	REQUEST_SAVE_WEIGHT_SUCCESS,
	REQUEST_UPDATE_SETTINGS,
	REQUEST_USER_DATA,
	REQUEST_USER_DATA_FAILURE,
	REQUEST_USER_DATA_LOADING,
	REQUEST_USER_DATA_NOCHANGE,
	REQUEST_USER_DATA_SUCCESS,
} from './profile.actionTypes';

export const actionCreators = {
	doChangeAnamnesisDisclaimerAccepted: (anamnesisDisclaimerAccepted: boolean) => ({
		type: CHANGE_ANAMNESIS_DISCLAIMER_ACCEPTED,
		anamnesisDisclaimerAccepted,
	}),
	doLoadUserData: () => ({
		type: REQUEST_USER_DATA,
	}),
	doLoadUserDataLoading: (status: any) => ({
		type: REQUEST_USER_DATA_LOADING,
		status,
	}),
	doLoadUserDataNoChange: () => ({
		type: REQUEST_USER_DATA_NOCHANGE,
	}),
	doLoadUserDataSuccess: (data: ProfileDataType) => ({
		type: REQUEST_USER_DATA_SUCCESS,
		data,
	}),
	doLoadUserDataError: (error: Error) => ({
		type: REQUEST_USER_DATA_FAILURE,
		userData: {},
		error,
	}),
	doSaveCoach: (data: any) => ({
		type: REQUEST_SAVE_COACH,
		data,
	}),
	doSaveParticipateCompetition: (isParticipating: boolean) => ({
		type: REQUEST_SAVE_PARTICIPATE_COMPETITION,
		isParticipating,
	}),
	doSaveCoachError: (error: any) => ({
		type: REQUEST_SAVE_COACH_FAILURE,
		error,
	}),
	doSaveCoachSuccess: (data: any) => ({
		type: REQUEST_SAVE_COACH_SUCCESS,
		data,
	}),
	doSaveGender: (data: any) => ({
		type: REQUEST_SAVE_GENDER,
		data,
	}),
	doSaveGenderError: (error: any) => ({
		type: REQUEST_SAVE_GENDER_FAILURE,
		error,
	}),
	doSaveGenderSuccess: (data: any) => ({
		type: REQUEST_SAVE_GENDER_SUCCESS,
		data,
	}),
	doSaveAge: (data: any) => ({
		type: REQUEST_SAVE_AGE,
		data,
	}),
	doSaveAgeError: (error: any) => ({
		type: REQUEST_SAVE_AGE_FAILURE,
		error,
	}),
	doSaveAgeSuccess: (data: any) => ({
		type: REQUEST_SAVE_AGE_SUCCESS,
		data,
	}),
	doSaveWeight: (data: any) => ({
		type: REQUEST_SAVE_WEIGHT,
		data,
	}),
	doSaveWeightError: (error: any) => ({
		type: REQUEST_SAVE_WEIGHT_FAILURE,
		error,
	}),
	doSaveWeightSuccess: (data: any) => ({
		type: REQUEST_SAVE_WEIGHT_SUCCESS,
		data,
	}),
	doSaveHeight: (data: any) => ({
		type: REQUEST_SAVE_HEIGHT,
		data,
	}),
	doSaveHeightError: (error: any) => ({
		type: REQUEST_SAVE_HEIGHT_FAILURE,
		error,
	}),
	doSaveHeightSuccess: (data: any) => ({
		type: REQUEST_SAVE_HEIGHT_SUCCESS,
		data,
	}),
	doSaveHealthTarget: (data: { selectedHealthGoal?: HealthGoalTypesType }) => ({
		type: REQUEST_SAVE_HEALTH_TARGET,
		data,
	}),
	doSaveHealthTargetError: (error: any) => ({
		type: REQUEST_SAVE_HEALTH_TARGET_FAILURE,
		error,
	}),
	doSaveHealthTargetSuccess: (data: ResponseSetTempHealthTargetData) => {
		return {
			type: REQUEST_SAVE_HEALTH_TARGET_SUCCESS,
			data,
		};
	},
	doSaveAcceptHealthTarget: (data: {
		acceptedHealthGoalWarningUnderweight: boolean;
		acceptedHealthGoalWarningOverweight: boolean;
		acceptedHealthGoalWarningPregnant: boolean;
		healthGoal: HealthGoalTypesType;
		weightReduceGoal: number;
	}) => ({
		type: REQUEST_SAVE_ACCEPT_HEALTH_TARGET,
		data,
	}),
	doSaveAcceptHealthTargetError: (error: any) => ({
		type: REQUEST_SAVE_ACCEPT_HEALTH_TARGET_FAILURE,
		error,
	}),
	doSaveAcceptHealthTargetSuccess: (data: any) => ({
		type: REQUEST_SAVE_ACCEPT_HEALTH_TARGET_SUCCESS,
		data,
	}),
	doSaveActivityLevel: (data: any) => ({
		type: REQUEST_SAVE_ACTIVITY_LEVEL,
		data,
	}),
	doSaveActivityLevelError: (error: any) => ({
		type: REQUEST_SAVE_ACTIVITY_LEVEL_FAILURE,
		error,
	}),
	doSaveActivityLevelSuccess: (data: any) => ({
		type: REQUEST_SAVE_ACTIVITY_LEVEL_SUCCESS,
		data,
	}),
	doSaveDietaryHabits: (data: any) => ({
		type: REQUEST_SAVE_DIETARY_HABITS,
		data,
	}),
	doSaveDietaryHabitsError: (error: any) => ({
		type: REQUEST_SAVE_DIETARY_HABITS_FAILURE,
		error,
	}),
	doSaveDietaryHabitsSuccess: (data: any) => ({
		type: REQUEST_SAVE_DIETARY_HABITS_SUCCESS,
		data,
	}),
	doSaveDsgvo: (data: any) => ({
		type: REQUEST_SAVE_DSGVO,
		data,
	}),
	doSaveDsgvoError: (error: any) => ({
		type: REQUEST_SAVE_DSGVO_FAILURE,
		error,
	}),
	doSaveDsgvoSuccess: (data: any) => ({
		type: REQUEST_SAVE_DSGVO_SUCCESS,
		data,
	}),
	doFinish: () => ({
		type: REQUEST_FINISH_ANAMNESIS,
	}),
	doFinishSuccess: (data: any) => ({
		type: REQUEST_FINISH_ANAMNESIS_SUCCESS,
		data,
	}),
	doFinishError: (error: any) => ({
		type: REQUEST_FINISH_ANAMNESIS_FAILURE,
		error,
	}),

	doSaveSlogan: (slogan: string) => ({
		type: REQUEST_SAVE_SLOGAN,
		slogan,
	}),
	doSaveSloganSuccess: (slogan: string) => ({
		type: REQUEST_SAVE_SLOGAN_SUCCESS,
		slogan,
	}),
	doSaveSloganError: () => ({
		type: REQUEST_SAVE_SLOGAN_FAILURE,
	}),
	doFinishOnboarding: () => ({
		type: REQUEST_FINISH_ONBOARDING,
	}),
	doFinishOnboardingLoading: (status: boolean) => ({
		type: REQUEST_FINISH_ONBOARDING_LOADING,
		status,
	}),
	doFinishOnboardingSuccess: (userData: any) => ({
		type: REQUEST_FINISH_ONBOARDING_SUCCESS,
		userData,
	}),
	doFinishOnboardingError: (error: any) => ({
		type: REQUEST_FINISH_ONBOARDING_FAILURE,
		error,
	}),
	doUpdateSettings: (settings: any) => ({
		type: REQUEST_UPDATE_SETTINGS,
		settings,
	}),
	doUpdateSettingsSuccess: (settings: any) => ({
		type: REQUEST_UPDATE_SETTINGS,
		settings,
	}),
	doUpdateSettingsFailure: (error: any) => ({
		type: REQUEST_UPDATE_SETTINGS,
		error,
	}),
};

export type ProfileActionType =
	| ReturnType<typeof actionCreators.doChangeAnamnesisDisclaimerAccepted>
	| ReturnType<typeof actionCreators.doLoadUserData>
	| ReturnType<typeof actionCreators.doLoadUserDataLoading>
	| ReturnType<typeof actionCreators.doLoadUserDataNoChange>
	| ReturnType<typeof actionCreators.doLoadUserDataSuccess>
	| ReturnType<typeof actionCreators.doLoadUserDataError>
	| ReturnType<typeof actionCreators.doSaveCoach>
	| ReturnType<typeof actionCreators.doSaveParticipateCompetition>
	| ReturnType<typeof actionCreators.doSaveCoachError>
	| ReturnType<typeof actionCreators.doSaveCoachSuccess>
	| ReturnType<typeof actionCreators.doSaveGender>
	| ReturnType<typeof actionCreators.doSaveGenderError>
	| ReturnType<typeof actionCreators.doSaveGenderSuccess>
	| ReturnType<typeof actionCreators.doSaveAge>
	| ReturnType<typeof actionCreators.doSaveAgeError>
	| ReturnType<typeof actionCreators.doSaveAgeSuccess>
	| ReturnType<typeof actionCreators.doSaveWeight>
	| ReturnType<typeof actionCreators.doSaveWeightError>
	| ReturnType<typeof actionCreators.doSaveWeightSuccess>
	| ReturnType<typeof actionCreators.doSaveHeight>
	| ReturnType<typeof actionCreators.doSaveHeightError>
	| ReturnType<typeof actionCreators.doSaveHeightSuccess>
	| ReturnType<typeof actionCreators.doSaveHealthTarget>
	| ReturnType<typeof actionCreators.doSaveHealthTargetError>
	| ReturnType<typeof actionCreators.doSaveHealthTargetSuccess>
	| ReturnType<typeof actionCreators.doSaveAcceptHealthTarget>
	| ReturnType<typeof actionCreators.doSaveAcceptHealthTargetError>
	| ReturnType<typeof actionCreators.doSaveAcceptHealthTargetSuccess>
	| ReturnType<typeof actionCreators.doSaveActivityLevel>
	| ReturnType<typeof actionCreators.doSaveActivityLevelError>
	| ReturnType<typeof actionCreators.doSaveActivityLevelSuccess>
	| ReturnType<typeof actionCreators.doSaveDietaryHabits>
	| ReturnType<typeof actionCreators.doSaveDietaryHabitsError>
	| ReturnType<typeof actionCreators.doSaveDietaryHabitsSuccess>
	| ReturnType<typeof actionCreators.doSaveDsgvo>
	| ReturnType<typeof actionCreators.doSaveDsgvoError>
	| ReturnType<typeof actionCreators.doSaveDsgvoSuccess>
	| ReturnType<typeof actionCreators.doFinish>
	| ReturnType<typeof actionCreators.doFinishSuccess>
	| ReturnType<typeof actionCreators.doFinishError>
	| ReturnType<typeof actionCreators.doSaveSlogan>
	| ReturnType<typeof actionCreators.doSaveSloganSuccess>
	| ReturnType<typeof actionCreators.doSaveSloganError>
	| ReturnType<typeof actionCreators.doFinishOnboarding>
	| ReturnType<typeof actionCreators.doFinishOnboardingLoading>
	| ReturnType<typeof actionCreators.doFinishOnboardingSuccess>
	| ReturnType<typeof actionCreators.doFinishOnboardingError>
	| ReturnType<typeof actionCreators.doUpdateSettings>
	| ReturnType<typeof actionCreators.doUpdateSettingsSuccess>
	| ReturnType<typeof actionCreators.doUpdateSettingsFailure>;
